const ReportsMenuStructure = {
  title: "Reports",
  links: [
    {
      title: "Home",
      href: "reports",
      exact: true,
    },
    {
      title: "Sales Reports",
      href: "reports/sales",
    },
    {
      title: "Stock Reports",
      href: "reports/stock",
    },
    {
      title: "Store Credit Reports",
      href: "reports/store-credit",
    },
    {
      title: "Online Buylist Reports",
      href: "reports/buylists",
    },
  ],
};

/**
 * Returns a ReportsMenuStructure with the Data Exports tab conditionally
 * appended based on the Split.io feature flag.
 */
export function getReportsMenuStructure(dataExportsEnabled) {
  if (!dataExportsEnabled) return ReportsMenuStructure;
  return {
    ...ReportsMenuStructure,
    links: [
      ...ReportsMenuStructure.links,
      {
        title: "Data Exports",
        href: "reports/data-exports",
      },
    ],
  };
}

export default ReportsMenuStructure;
